import React, {useState, useEffect} from 'react'
import {Modal, Button} from 'react-bootstrap'
import {useI18n} from '../../../../Utils/_helpers/useI18n'
import {KTSVG} from '../../../../../_metronic/helpers'
import {TagSelect} from '../../Contacts/Components/TagSelect'
import {useContactTags} from '../hooks/useContactTags'

export interface TagOption {
  value: string
  label: string
  color: string
}

interface TagModalProps {
  show: boolean
  onClose: () => void
  onSave: (tags: TagOption[]) => void
  initialTags?: TagOption[]
  contactIds: string[]
  fetchContacts: (options?: { forceRefresh?: boolean }) => void
}

export const TagModal: React.FC<TagModalProps> = ({
  show,
  onClose,
  onSave,
  initialTags = [],
  contactIds,
  fetchContacts,
}) => {
  const {t} = useI18n()
  const [selectedTags, setSelectedTags] = useState<TagOption[]>(initialTags)
  const {addTags} = useContactTags({ fetchContacts })
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    addTags(contactIds, selectedTags)
    onClose()
  }

  const handleClose = () => {
    onClose()
  }

  // Reset selected tags when modal is opened
  useEffect(() => {
    if (show) {
      setSelectedTags(initialTags)
    }
  }, [show])

  return (
    <Modal backdrop='static' dialogClassName='modal-dialog-centered' show={show} size='lg'>
      <div className='modal-header'>
        <h1>{t('RAW_CONTACT_COLLECTION.TAG_MODAL.TITLE')}</h1>
        <div className='btn btn-icon btn-sm' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
      </div>
      <div className='modal-body px-10'>
        <div className='row mb-4'>
          <label className='p-0 mb-1'>{t('RAW_CONTACT_COLLECTION.TAG_MODAL.LABEL')}</label>
          <TagSelect
            value={selectedTags}
            onChange={setSelectedTags}
            className='react-tags-selectbox'
          />
        </div>
      </div>
      <div className='modal-footer'>
        <button className='btn btn-danger' onClick={handleClose}>
          {t('COMMON.CLOSE')}
        </button>
        <Button onClick={handleSubmit}>{t('COMMON.SAVE')}</Button>
      </div>
    </Modal>
  )
}
